import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useOutOfPocketMaxSchedule from "./hooks/useOutOfPocketMaxSchedule";

const OutOfPocketMaxSchedule = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectModeParamData,
  onNavigate,
}) => {
  const outOfPocketMaxScheduleData = useOutOfPocketMaxSchedule(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectModeParamData,
    onNavigate
  );
  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={outOfPocketMaxScheduleData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {outOfPocketMaxScheduleData.screen_title} -{" "}
          <span className="heading-cod">
            {outOfPocketMaxScheduleData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={outOfPocketMaxScheduleData.formFields}
        dropdownValues={outOfPocketMaxScheduleData.dropdownValues}
        paramsData={outOfPocketMaxScheduleData.paramsData}
        updataParamData={outOfPocketMaxScheduleData.updateParamData}
        disabledDropdowns={outOfPocketMaxScheduleData.disabledDropdowns}
      />
      <ButtonsSection ctaButtons={outOfPocketMaxScheduleData.ctaButtons} />
      <DisplayTable
        selectMode={outOfPocketMaxScheduleData.selectMode}
        data={outOfPocketMaxScheduleData.data}
        parmKey={outOfPocketMaxScheduleData.parmKey}
        statusKey={outOfPocketMaxScheduleData.statusKey}
        menuOptions={outOfPocketMaxScheduleData.menuOptions}
        tableHeaders={outOfPocketMaxScheduleData.columnDef}
        setRowData={outOfPocketMaxScheduleData.setRowData}
        selectedPriceSchedules={outOfPocketMaxScheduleData.selectedRows}
        setSelectedPriceSchedules={outOfPocketMaxScheduleData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={outOfPocketMaxScheduleData.first}
          rows={outOfPocketMaxScheduleData.rows}
          totalRecords={outOfPocketMaxScheduleData.totalRecords}
          currentPage={outOfPocketMaxScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={outOfPocketMaxScheduleData.onPageChange}
        />
      </div>
      {outOfPocketMaxScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={outOfPocketMaxScheduleData.isConfirmationModalOpen}
          onRequestClose={outOfPocketMaxScheduleData.closeConfirmationModal}
          onBack={outOfPocketMaxScheduleData.closeConfirmationModal}
          onSave={outOfPocketMaxScheduleData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={outOfPocketMaxScheduleData.setSelectedOption}
        />
      )}
      {outOfPocketMaxScheduleData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={outOfPocketMaxScheduleData.isHideConfirmationModalOpen}
          onRequestClose={outOfPocketMaxScheduleData.closeHideConfirmationModal}
          onBack={outOfPocketMaxScheduleData.closeHideConfirmationModal}
          onSave={outOfPocketMaxScheduleData.hidePocketSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={outOfPocketMaxScheduleData.setHideSelectedOption}
        />
      )}
    </div>
  );
};
export default OutOfPocketMaxSchedule;
